import React from 'react'
import MessengerSection from './MessengerSection'
import { connect } from 'react-redux'
import Bar from '../../v2/Bar'
import {
    genEmailButton,
    getAttachmentsUrls,
    getChatStatus,
    getRequestedVia,
    getStarsJSX,
    setFeedbackDetail,
    updateModalContent
} from '../../redux/FeedbackRedux'

class MessengerChatDetail extends React.Component {
    constructor(props) {
        super(props);
        this.handleForwardClick = this.handleForwardClick.bind(this);
        this.handleHistoryClick = this.handleHistoryClick.bind(this);
    }

    handleForwardClick() {
        event.preventDefault();
        var modal_id = "textForwardModal";
        var modal_title = __('Forward Via Text Message');
        var modal_body = "renderTextForward";
        var button_1_class = "outline-secondary";
        var button_1_id = "cancel";
        var button_1_text = __('Cancel');
        var button_2_class = "primary";
        var button_2_id = "send";
        var button_2_text = __('Send Text Message');
        this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
        jQuery('.modal:not(.error)').modal();
    }

    handleHistoryClick() {
        event.preventDefault();
        var modal_id = "forwardHistoryModal";
        var modal_title = __('Forward History For This Feedback');
        var modal_body = "renderForwardHistory";
        var button_1_class = "outline-secondary";
        var button_1_id = "cancel";
        var button_1_text = __('Close');
        var button_2_class = "hide";
        var button_2_id = "none";
        var button_2_text = "none";
        this.props.dispatch(updateModalContent({ modal_id: modal_id, modal_title: modal_title, modal_body: modal_body, button_1_class: button_1_class, button_1_id: button_1_id, button_1_text: button_1_text, button_2_class: button_2_class, button_2_id: button_2_id, button_2_text: button_2_text }));
        jQuery('.modal:not(.error)').modal();
    }

    handleBackClick() {
        this.props.dispatch(setFeedbackDetail(null));
    }

    render() {

        var response_via_text = getRequestedVia(this.props.feedback);

        const { chat_alert, chat_button_text } = getChatStatus(this.props.feedback);

        const stars = getStarsJSX(this.props.feedback.ratethisbizrating ? this.props.feedback.ratethisbizrating.rating : null);

        const attachments = getAttachmentsUrls(this.props.feedback);

        var email_forward = genEmailButton(this.props.feedback, 'dropdown-item text-primary');

        var tags =
            this.props.state.business &&
            this.props.state.business.tags &&
            this.props.state.business.tags.length > 0;

        return (
            <div className="col-12 feedback-detail mb-10 is-hidden-mobile" id={this.props.center ? "center-detail" : null}>
                <Bar middleCenter>
                    <div className='mr-1'>
                        <h4 className='left-carat mb-0 cursor-pointer' onClick={this.handleBackClick.bind(this)}></h4>
                    </div>
                    <h5 className='text-nowrap d-flex align-items-center mb-0'>
                        {(this.props.feedback.user.firstname + " " + (this.props.feedback.user.lastname ?? '')) ?? __('Anonymous')}
                    </h5>
                    <div className='ml-auto'>
                        {this.props.feedback.response_time ? <h5 className="text-muted mb-0">Response time: {this.props.feedback.response_time}</h5> : null}
                        {(this.props.feedback.chat_status === "Chat Not Started" ? <h5 className="chat-alert-message pb-0 pt-0 mb-0 mt-0 anim-pulse d-inline"><i className="fas fa-exclamation-triangle text-warning mr-1"></i>{this.props.feedback.chat_status}</h5> : "")}
                    </div>
                    <div className='ml-2'>
                        <a href={"/feedback/" + this.props.feedback.feedback_id + "/selected"} className="btn btn-sm btn-default btn-outline-primary">
                            <i className="fas fa-share-square mr-2"></i> {__('View Feedback')}
                        </a>
                    </div>
                </Bar>

                <div className="feedback-detail chat-detail scroll">
                    <MessengerSection feedback={this.props.feedback} />

                </div>
            </div>
        );
    }

}

function mapStateToProps(state) {
    return { feedback: state.feedback_detail, current_user: state.current_user }
}

export default connect(mapStateToProps)(MessengerChatDetail)
